/**
 * Event Column Definitions
 * Defines all available columns for the events table with metadata
 */

export const AVAILABLE_COLUMNS = {
  event_name: { 
    label: 'Event Name', 
    field: 'event_name', 
    category: 'core',
    default: true,
    required: true
  },
  session_id: { 
    label: 'Session ID', 
    field: 'session_uuid', 
    category: 'session',
    default: true,
    fallbackField: 'session_id'
  },
  distinct_id: { 
    label: 'Distinct ID', 
    field: 'distinct_id', 
    category: 'session',
    default: true
  },
  event_category: { 
    label: 'Category', 
    field: 'event_category', 
    category: 'core'
  },
  country: { 
    label: 'Country', 
    field: 'country', 
    category: 'location',
    default: true
  },
  latitude: {
    label: 'Latitude',
    field: 'latitude',
    category: 'location',
  },
  longitude: {
    label: 'Longitude',
    field: 'longitude',
    category: 'location',
  },
  city: { 
    label: 'City', 
    field: 'city', 
    category: 'location'
  },
  region: { 
    label: 'Region', 
    field: 'region', 
    category: 'location'
  },
  timezone: { 
    label: 'Timezone', 
    field: 'timezone', 
    category: 'location'
  },
  browser_name: { 
    label: 'Browser', 
    field: 'browser_name', 
    category: 'device'
  },
  os: { 
    label: 'OS', 
    field: 'os', 
    category: 'device',
    default: true
  },
  device_type: { 
    label: 'Device Type', 
    field: 'device_type', 
    category: 'device'
  },
  is_web3_user: { 
    label: 'Is Web3 User', 
    field: 'is_web3_user', 
    category: 'web3',
    formatter: 'boolean'
  },
  wallet_address: { 
    label: 'Wallet Address', 
    field: 'wallet_address', 
    category: 'web3'
  },
  timestamp: { 
    label: 'Time', 
    field: 'timestamp', 
    category: 'core',
    formatter: 'time',
    required: true,
    default: true
  }
};

// Default columns configuration
export const DEFAULT_COLUMNS = {
  enabled: ['event_name', 'session_id', 'distinct_id', 'country', 'os', 'timestamp'],
  order: ['event_name', 'session_id', 'distinct_id', 'country', 'os', 'timestamp']
};

// Column categories for organization
export const COLUMN_CATEGORIES = {
  core: 'Core',
  session: 'Session',
  location: 'Location',
  device: 'Device',
  web3: 'Web3'
};

/**
 * Get column definition by key
 */
export const getColumnDefinition = (columnKey) => {
  return AVAILABLE_COLUMNS[columnKey] || null;
};

/**
 * Get all available column keys
 */
export const getAvailableColumnKeys = () => {
  return Object.keys(AVAILABLE_COLUMNS);
};

/**
 * Get columns grouped by category
 */
export const getColumnsByCategory = () => {
  const grouped = {};
  Object.keys(AVAILABLE_COLUMNS).forEach(key => {
    const column = AVAILABLE_COLUMNS[key];
    const category = column.category || 'other';
    if (!grouped[category]) {
      grouped[category] = [];
    }
    grouped[category].push({ key, ...column });
  });
  return grouped;
};
